import * as React from 'react'
import { Box, Typography, Link, IconButton } from '@mui/material'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'

export function Footer() {
  return (
    <Box
      component='footer'
      sx={{
        backgroundColor: 'background.paper',
        py: 3,
        px: 2,
        width: '100%',
        borderTop: '1px solid',
        borderColor: 'divider',
        mt: 'auto'
      }}
    >
      <Box
        sx={{
          maxWidth: 'lg',
          mx: 'auto',
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography variant='body2' color='text.secondary' align='center' sx={{ mb: { xs: 2, sm: 0 } }}>
          © {new Date().getFullYear()} Clair de Scène. Tous droits réservés.
        </Typography>

        <Box sx={{ display: 'flex', gap: { xs: 0, sm: 2 } }}>
          <IconButton
            aria-label='Facebook'
            component={Link}
            href='https://www.facebook.com/share/1B2rajxgbv/?mibextid=wwXIfr'
            target='_blank'
            rel='noopener noreferrer'
            color='inherit'
          >
            <FacebookIcon />
          </IconButton>

          <IconButton
            aria-label='Instagram'
            component={Link}
            href='https://www.instagram.com/clair.de.scene'
            target='_blank'
            rel='noopener noreferrer'
            color='inherit'
          >
            <InstagramIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  )
}
